export const ficheTableauData = (state) => state.ficheTableauData
export const currentFiche = (state) => state.currentFiche
export const currentLigne = (state) => state.currentLigne
export const currentFicheData = (state) => state.currentFicheData
export const selectedFiches = (state) => state.selectedFiches
export const getFicheInfo = (state) => {
  if (state.currentFiche == null || !state.currentFicheData || !state.ficheTableauData) return

  // const { onglet, ligne, data: ficheData } = state.currentFicheData
  var onglet = state.currentFicheData.onglet
  var ligne = state.currentFicheData.ligne
  var data = state.currentFicheData.data
  var newLine = state.currentFicheData.newLine
  // var theRows = []
  //

  var isEnsemble = false
  var ftdata = state.ficheTableauData.find(el => el.id === onglet)
  // if (ftdata.projectName === "Projet essais calculs") {
  for (var i = 0; i < ftdata.rows.length; i++) {
    if (ftdata.rows[i] && typeof ftdata.rows[i] !== 'undefined' && ftdata.rows[i].type === 'ensemble') {
      // delete ftdata.data[i]

      // ligne = parseInt(ligne) + 1
      // //
      // isEnsemble = true
      // break
    }
  }
  // }
  console.log(window.ligne)
  if (typeof window.ligne !== 'undefined') {
    ligne = window.ligne
  } else if (newLine) {
    ligne = newLine
  }

  const headerKeys = ftdata.columns.map(el => el.key)

  const mappedEspace = ftdata.data[ligne].reduce((acc, curr, index) => {
    if (ftdata.formulaValue && curr && ('' + curr).startsWith('=')) {
      const jexcel = require('jexcel')
      const colName = jexcel.getColumnNameFromId([index, ligne])

      acc[`${headerKeys[index]}`] = isNaN(ftdata.formulaValue[colName]) ? Math.round(eval(curr.split('=')[1])) : ftdata.formulaValue[colName]
      return acc
    }

    acc[`${headerKeys[index]}`] = curr
    return acc
  }, {})
  const mappedUnit = ftdata.columns.reduce((acc, curr, index) => {
    acc[headerKeys[index]] = curr.unit || ''
    return acc
  }, {})
  const mappedFormat = ftdata.columns.reduce((acc, curr, index) => {
    acc[headerKeys[index]] = curr.displayFormat || 'none'
    return acc
  }, {})

  const mappedHeaders = ftdata.data[0].map((el, index) => {
    return {
      titre: el,
      key: headerKeys[index]
    }
  })

  var mappedHeaderKeys = mappedHeaders.reduce((acc, curr, index) => {
    acc[`${headerKeys[index]}`] = curr.titre
    return acc
  }, {})
  mappedHeaderKeys['C56'] = 'Type'
  mappedHeaderKeys['C57'] = 'Nom'
  mappedHeaderKeys['C58'] = 'Adresse'
  mappedHeaderKeys['C59'] = 'Complément d\'adresse'
  mappedHeaderKeys['C60'] = 'Code postal'
  mappedHeaderKeys['C61'] = 'Ville'
  mappedHeaderKeys['C62'] = 'Pays'
  mappedHeaderKeys['C63'] = 'Nom du contact'
  mappedHeaderKeys['C64'] = 'Prénom du contact'
  mappedHeaderKeys['C65'] = 'Téléphone'
  mappedHeaderKeys['C66'] = 'Mobile'
  mappedHeaderKeys['C67'] = 'Email 1'
  mappedHeaderKeys['C68'] = 'Email 2'

  if (ftdata.client) {
    mappedEspace['C56'] = ftdata.client.type
    mappedEspace['C57'] = ftdata.client.nom
    mappedEspace['C58'] = ftdata.client.adresse
    mappedEspace['C59'] = ftdata.client.complement_adresse
    mappedEspace['C60'] = ftdata.client.code_postal
    mappedEspace['C61'] = ftdata.client.ville
    mappedEspace['C62'] = ftdata.client.pays
    mappedEspace['C63'] = ftdata.client.nom_du_contact
    mappedEspace['C64'] = ftdata.client.prenom_du_contact
    mappedEspace['C65'] = ftdata.client.telephone
    mappedEspace['C66'] = ftdata.client.mobile
    mappedEspace['C67'] = ftdata.client.email1
    mappedEspace['C68'] = ftdata.client.email2
  }

  mappedFormat['C56'] = ''
  mappedFormat['C57'] = ''
  mappedFormat['C58'] = ''
  mappedFormat['C59'] = ''
  mappedFormat['C60'] = ''
  mappedFormat['C61'] = ''
  mappedFormat['C62'] = ''
  mappedFormat['C63'] = ''
  mappedFormat['C64'] = ''
  mappedFormat['C65'] = ''
  mappedFormat['C66'] = ''
  mappedFormat['C67'] = ''
  mappedFormat['C68'] = ''

  mappedUnit['C56'] = ''
  mappedUnit['C57'] = ''
  mappedUnit['C58'] = ''
  mappedUnit['C59'] = ''
  mappedUnit['C60'] = ''
  mappedUnit['C61'] = ''
  mappedUnit['C62'] = ''
  mappedUnit['C63'] = ''
  mappedUnit['C64'] = ''
  mappedUnit['C65'] = ''
  mappedUnit['C66'] = ''
  mappedUnit['C67'] = ''
  mappedUnit['C68'] = ''

  mappedHeaderKeys['P01'] = 'Dénomination'
  mappedHeaderKeys['P02'] = 'Type(s) d\'équipement(s)'
  mappedHeaderKeys['P03'] = 'Numéro d\'affaire'
  mappedHeaderKeys['P04'] = 'Nom du contact'
  mappedHeaderKeys['P05'] = 'Email du contact'
  mappedHeaderKeys['P06'] = 'Téléphone'
  mappedHeaderKeys['P07'] = 'Mobile'
  mappedHeaderKeys['P08'] = 'Adresse'
  mappedHeaderKeys['P09'] = 'Complément d\'adresse'
  mappedHeaderKeys['P10'] = 'Code Postal'
  mappedHeaderKeys['P11'] = 'Ville'
  mappedHeaderKeys['P12'] = 'Type d\'opération'

  if (ftdata.projectData) {
    mappedEspace['P01'] = ftdata.projectData.nom
    mappedEspace['P02'] = ftdata.projectData.typeErp
    mappedEspace['P03'] = ftdata.projectData.numeroAffaire
    mappedEspace['P04'] = ftdata.projectData.contactNom
    mappedEspace['P05'] = ftdata.projectData.contactEmail
    mappedEspace['P06'] = ftdata.projectData.contactTel1
    mappedEspace['P07'] = ftdata.projectData.contactTel2
    mappedEspace['P08'] = ftdata.projectData.adresse
    mappedEspace['P09'] = ftdata.projectData.complementAdresse
    mappedEspace['P10'] = ftdata.projectData.codePostal
    mappedEspace['P11'] = ftdata.projectData.ville
    mappedEspace['P12'] = ftdata.projectData.typeOperations
  }

  mappedFormat['P01'] = ''
  mappedFormat['P02'] = ''
  mappedFormat['P03'] = ''
  mappedFormat['P04'] = ''
  mappedFormat['P05'] = ''
  mappedFormat['P06'] = ''
  mappedFormat['P07'] = ''
  mappedFormat['P08'] = ''
  mappedFormat['P09'] = ''
  mappedFormat['P10'] = ''
  mappedFormat['P11'] = ''
  mappedFormat['P12'] = ''

  mappedUnit['P01'] = ''
  mappedUnit['P02'] = ''
  mappedUnit['P03'] = ''
  mappedUnit['P04'] = ''
  mappedUnit['P05'] = ''
  mappedUnit['P06'] = ''
  mappedUnit['P07'] = ''
  mappedUnit['P08'] = ''
  mappedUnit['P09'] = ''
  mappedUnit['P10'] = ''
  mappedUnit['P11'] = ''
  mappedUnit['P12'] = ''
  if (state.isProjectTemplate) {
    return {
      listColonne: ftdata.colAddedToFiche
        ? mappedHeaders.filter((el) => el.titre && ficheData.colAddedToFiche.indexOf(el.key) === -1)
        : mappedHeaders.filter((el) => el.titre),
      espaceData: mappedEspace,
      dataUnit: mappedUnit,
      dataFormat: mappedFormat,
      mappedHeaderKeys,
      ligne,
      onglet
    }
  }

  console.log(mappedEspace)
  return {
    listColonne: ftdata.rows[ligne].colAddedToFiche
      ? mappedHeaders.filter((el) => el.titre && ftdata.rows[ligne].colAddedToFiche.indexOf(el.key) === -1)
      : mappedHeaders.filter((el) => el.titre),
    espaceData: mappedEspace,
    client: ftdata.client,
    dataUnit: mappedUnit,
    dataFormat: mappedFormat,
    mappedHeaderKeys,
    ligne,
    onglet
  }
}
export const templatesFiche = (state) => state.templatesFiche
export const templateId = (state) => state.templateId
export const isLoadingTemplatesFiche = (state) => state.isLoadingTemplatesFiche
export const droppedHeaders = (state) => state.droppedHeaders
export const deletedHeaders = (state) => state.deletedHeaders
export const lastFiche = (state) => state.lastFiche
export const isLoadingFicheData = (state) => state.isLoadingFicheData
export const isLoadingFicheEspaces = (state) => state.isLoadingFicheEspaces
export const tableauTemplateId = (state) => state.tableauTemplateId



// WEBPACK FOOTER //
// ./src/store/modules/ficheEspace/getters.js